const originalComponentPropertiesToTransfer = ['fetchData', 'getPageMetadata'];

/**
 * Copies certain static properties from the decorator component to the decorated component.
 *
 * @param  {Object} options.DecoratedComponent Decorated component class.
 * @param  {Object} options.OriginalComponent  Original component class.
 * @param  {string} options.displayNameSuffix  Display name suffix to add.
 * @return {undefined}
 */
export default function configureDecoratedComponent({
  DecoratedComponent,
  OriginalComponent,
  displayNameSuffix,
}) {
  // Pass in whitelisted properties to decorated component.
  for (const propertyName of originalComponentPropertiesToTransfer) {
    DecoratedComponent[propertyName] = OriginalComponent[propertyName];
  }

  // Set displayName of decorated component.
  const displayNameOfOriginalComponent = OriginalComponent.displayName || OriginalComponent.name;

  DecoratedComponent.displayName = `${displayNameOfOriginalComponent}${displayNameSuffix || ''}`;

  return DecoratedComponent;
}
